<template>
    <p></p>
</template>
<script setup lang="ts">
const alternates = [
  { rel: "alternate", hreflang: "en", href: "%page_url_en" },
  { rel: "alternate", hreflang: "pt-br", href: "%page_url_pt" },
  { rel: "alternate", hreflang: "x-default", href: "%page_url_pt" },
];
// idiomas sem equivalente para a página atual (useHreflangAusente)
const route = useRoute();
const estadoHreflang = useHreflangAusenteEstado();
const hreflangAusente = computed(() => estadoHreflang.value[route.path] ?? []);

useHead({
  templateParams: {
    separator: "|",
  },
  title: "%subPage",
  titleTemplate: "%s",
  meta: [
    {
      name: "robots",
      content: "index, follow",
    },
    {
      name: "theme-color",
      content: "#fff",
    },
    {
      name: "author",
      content: "Bella da Semana",
    },
    {
      name: "copyright",
      content:
        "&copy; 2001 - " + new Date().getFullYear() + ". Bella Entretenimento Ltda.",
    },
    {
      name: "title",
      content: "%s",
    },
    {
      name: "identifier-url",
      content: "%page_url",
    },
    {
      name: "description",
      content: "%page_description",
    },
    {
      name: "keywords",
      content: "%page_keywords",
    },
    {
      name: "googlebot",
      content:
        "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    },
    {
      name: "bingbot",
      content:
        "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
      tagPriority: -10
    },
    {
      name: "twitter:site",
      content: "@belladasemana",
      tagPriority: -10
    },
    {
      name: "twitter:title",
      content: "%s",
      tagPriority: -10
    },
    {
      name: "twitter:description",
      content: "%page_description",
      tagPriority: -10
    },
    {
      name: "twitter:image",
      content: "%page_image",
      tagPriority: -10
    },
    {
      property: "og:title",
      content: "%s",
      tagPriority: -10
    },
    {
      property: "og:description",
      content: "%page_description",
      tagPriority: -10
    },
    {
      property: "og:type",
      content: "website",
      tagPriority: -10
    },
    {
      property: "og:image",
      content: "%page_image",
      tagPriority: -10
    },
    {
      property: "og:image:type",
      content: "image/jpeg",
      tagPriority: -10
    },
    {
      // Alt textual da imagem de preview (acessibilidade + sinal p/ IAs).
      // Reusa o título da página (`%s`), que descreve o contexto do card.
      property: "og:image:alt",
      content: "%s",
      tagPriority: -10
    },
    {
      property: "og:url",
      content: "%page_url",
      tagPriority: -10
    },
    {
      property: "og:site_name",
      content: "%s",
      tagPriority: -10
    },
  ],
  link: computed(() => [
    {
      rel: "canonical",
      href: "%page_canonical",
    },
    ...alternates.filter(({ hreflang }) => {
      // x-default aponta para o pt-br: sem pt-br, sai junto
      const idioma = hreflang === "x-default" ? "pt-br" : hreflang;
      return !hreflangAusente.value.includes(idioma);
    }),
  ]),
  htmlAttrs: {
    lang: "%page_locale"
  }
});
</script>
